import { call, put, takeEvery } from 'redux-saga/effects';
import { getTipsterPreferences } from '../../api/tipsterPreferences';
import { tipsterPreferencesActions } from '../../store/tipsterPreferences/actions';
import { TIPSTER_PREFERENCES_REQUEST } from '../../constants/tipsterPreferences';

function* tipsterPreferencesRequestSaga(action: any): any {
  try {
    const tipster_preferences = yield call(
      getTipsterPreferences,
      action.payload,
    );

    const superStakeAvailableAt =
      tipster_preferences.next_super_confidence_tip_available_at || new Date();

    var diffTime =
      new Date(superStakeAvailableAt).valueOf() - new Date().valueOf();
    const unformattedDays = diffTime / (24 * 60 * 60 * 1000);
    const unformattedHours = (unformattedDays % 1) * 24;
    const unformattedMinutes = (unformattedHours % 1) * 60;
    const until_super_confidence_available = {
      until_super_confidence_available: {
        days: Math.floor(unformattedDays),
        hours: Math.floor(unformattedHours),
        minutes: Math.floor(unformattedMinutes),
      },
    };
    const is_super_confidence_available = {
      is_super_confidence_available:
        Math.floor(unformattedDays) <= 0 &&
        Math.floor(unformattedHours) <= 0 &&
        Math.floor(unformattedMinutes) <= 0,
    };
    const res = {
      ...tipster_preferences,
      ...until_super_confidence_available,
      ...is_super_confidence_available,
    };

    yield put(tipsterPreferencesActions.tipsterPreferencesSuccessAction(res));
  } catch (e: any) {
    yield put(tipsterPreferencesActions.tipsterPreferencesFailureAction(e));
  }
}
function* tipsterPreferencesSaga() {
  yield takeEvery(TIPSTER_PREFERENCES_REQUEST, tipsterPreferencesRequestSaga);
}

export default tipsterPreferencesSaga;
